/** Identidad del proveedor para el Libro de Reclamaciones (D.S. 011-2011-PCM). */
/** Pega el RUC de SUNAT de la clínica (11 dígitos). También puedes usar REACT_APP_CLINIC_RUC en .env */
export const CLINIC_RUC = '10445962207';

export const CLINIC_LEGAL = {
  tradeName: 'Smile Up',
  legalName: 'Smile Up',
  ruc: String(process.env.REACT_APP_CLINIC_RUC || CLINIC_RUC || '').trim(),
  establishmentAddress: 'Av. La Cultura 822, Wanchaq, Cusco, Perú',
  establishmentPhone: '(084) 607 539',
  establishmentEmail: 'clinicasmileupcusco@gmail.com',
  bookCode: 'SU-CUSCO-001',
  indecopiUrl: 'https://www.indecopi.gob.pe',
  indecopiConsumerUrl: 'https://consumidor.gob.pe/libro-de-reclamaciones/',
};
